import { render, staticRenderFns } from "./c-order-item.vue?vue&type=template&id=af4c7bfa&scoped=true&"
import script from "./c-order-item.vue?vue&type=script&lang=js&"
export * from "./c-order-item.vue?vue&type=script&lang=js&"
import style0 from "./c-order-item.vue?vue&type=style&index=0&id=af4c7bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4c7bfa",
  null
  
)

export default component.exports